/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable func-names */
import { AxiosResponse } from 'axios';
import {
  FalsePositiveCountInfo,
  SettingInfoModel,
} from 'core/models/settings/analysisSettingModel';
import { setSettingInfo } from 'reducers/settingInfo';
import { store } from 'store';

import { apiWrapper, axiosApi } from 'utils/api';

export function getBase64FromUrl(url: string) {
  return new Promise((resolve, reject) => {
    fetch(url)
      .then((response) => response.blob())
      .then((blob) => {
        const reader = new FileReader();
        reader.onloadend = function () {
          resolve(reader.result);
        };
        reader.readAsDataURL(blob);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

const getSetting = async (): Promise<AxiosResponse<SettingInfoModel> | void> => {
  const success = async (): Promise<AxiosResponse<SettingInfoModel>> => {
    const response = await axiosApi().get<SettingInfoModel>(
      `/analysis-settings/one`,
    );
    if (response) {
      const data_ = response.data;
      if (data_?.theme?.logoImage != null) {
        const { logoImage } = data_.theme;
        try {
          const base64Data = await getBase64FromUrl(logoImage);
          if (data_.theme != null) {
            data_.theme.logoImage = base64Data as string;
          }
        } catch (error) {
          console.error(error);
        }
      }
      store.dispatch(
        setSettingInfo({
          settingInfo: data_,
        }),
      );
    }
    return {
      ...response,
      data: response.data,
    };
  };

  return apiWrapper<SettingInfoModel>({
    success,
  });
};

interface IFP {
  patientDay?: string;
  processId?: string;
  patient?: string;
  startTime?: number;
  endTime?: number;
}
export const apiFalsePosotiveInfo = async (
  params: IFP,
): Promise<AxiosResponse<FalsePositiveCountInfo> | void> => {
  const success = async (): Promise<AxiosResponse<FalsePositiveCountInfo>> => {
    const response = await axiosApi().get<FalsePositiveCountInfo>(
      `/falsePositive/info`,
      {
        params,
      },
    );
    return response;
  };

  return apiWrapper<FalsePositiveCountInfo>({
    success,
  });
};

export default getSetting;
